/**
 * Reagent's palette, per `04-art-direction.md`: "cozy spectrum of warm creams, mustard
 * yellows, terracotta reds, and sage greens, accented by bright pastel fluid
 * colors ... for high reagent contrast." One module, so every material reads
 * the same tokens instead of re-deriving hex values.
 */

export const PALETTE = {
  // Warm workshop base tones
  cream: "#F2E8D5",
  creamDark: "#E4D5B8",
  mustard: "#E0A526",
  mustardDark: "#B8801A",
  terracotta: "#C6553C",
  terracottaDark: "#9C3F2C",
  sage: "#8FA97A",
  sageDark: "#6B8557",
  chassisGrey: "#8A8378",
  chassisGreyDark: "#5E594F",

  // Bright pastel fluids, for high reagent contrast against the warm base
  fluidSkyBlue: "#7FC7E8",
  fluidMagenta: "#E86FC0",
  fluidMintGreen: "#7FD9A8",
  fluidAmber: "#F2C14E",

  // Hazard / status accents
  hazardWarning: "#F2A03D",
  hazardCritical: "#E05C3C",
  hazardSpark: "#FFE066",

  // Lighting
  keyLight: "#FFD9A0",
  fillLight: "#C9D9C0",
  rimLight: "#FFEFD0",

  // Board / UI ground
  boardTop: "#D8C9A3",
  boardLip: "#B89F6E",
} as const;

export type PaletteKey = keyof typeof PALETTE;
